import _ from 'lodash'
import React from 'react'
import { connect } from 'react-redux'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import message from 'antd/lib/message'
import {siteUrl} from 'scripts/siteUrl';

import l8n from 'l8n'
import { getCurrentUser, setActiveDialog } from 'ducks/app'
import Dialog from 'components/CustomComponents/Layout/Dialog'

const mapStateToProps = (state, props) => ({
  user: getCurrentUser(state)
})

@connect(mapStateToProps)
class ReferralLink extends React.Component {
  copyReferralLink = () => {
    message.info(l8n.p_ref_link_copied)
  }

  getReferralLink = () => {
    const { user } = this.props

    const pricelists = {
      4: {host: 'https://www.jivochat.com', locale: 'en'},
      9: {host: 'https://www.jivochat.com.br', locale: 'pt'},
      17: {host: 'https://www.jivochat.es', locale: 'es'},
      25: {host: 'https://www.jivochat.ng', locale: 'en'},
      27: {host: 'https://www.jivochat.com.tr', locale: 'tr'},
      28: {host: 'https://www.jivochat.co.id', locale: 'id'},
      29: {host: 'https://www.jivochat.com.co', locale: 'es'},
      30: {host: 'https://www.jivochat.com.ar', locale: 'es'},
      31: {host: 'https://www.jivochat.cl', locale: 'es'},
      32: {host: 'https://www.jivochat.com.bo', locale: 'es'},
      33: {host: 'https://www.jivochat.mx', locale: 'es'},
      34: {host: 'https://www.jivochat.com.ve', locale: 'es'},
      36: {host: 'https://www.jivochat.co.ke', locale: 'en'},
      37: {host: 'https://www.jivochat.co.za', locale: 'en'},
      39: {host: 'https://www.jivochat.com.pe', locale: 'es'},
    }

    const activePricelistConfig = pricelists[user.pricelist_id]

    const domain = _.get(activePricelistConfig, 'host', false) || siteUrl()

    return `${domain}/?partner_id=${user.id}`
  }

  render() {
    return (
      <div>
        <span>{l8n.p_referralLink}</span>
        <Dialog 
          id="referral_link"
          title={(<h3>{l8n.p_referralLink}</h3>)}
          centered={true}
          width={640}
          DialogForm={
            <div>
              <p>{l8n.p_ref_link_click_to_copy}:</p>
              <p>
                <CopyToClipboard
                  text={this.getReferralLink()} 
                  onCopy={this.copyReferralLink}
                >
                  <span style={{fontSize: 18, cursor: 'pointer'}} className="cat__core__link--blue font-weight-bold" data-qa-id="referral-link" href={this.getReferralLink()}>{this.getReferralLink()}</span>
                </CopyToClipboard>
              </p>
              <p>{l8n.p_referralLinkComment}</p>
            </div>
          }
        />
      </div>
    )
  }
}

export default ReferralLink



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Link/ReferralLink/index.js